import type { AdminApiOrganization } from '@/types/serializers';

/** 日時文字列のハイフンをスラッシュに変換して表示用にする */
export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return '-';
  return value.replace(/-/g, '/');
};

/** 日付文字列のハイフンをスラッシュに変換して表示用にする */
export const formatDate = (value: string | null | undefined): string => {
  if (!value) return '-';
  return value.replace(/-/g, '/');
};

/** 契約終了日までの残り日数を数値で返す（無効な場合は null） */
export const getRemainingDays = (endDate: string | null | undefined): number | null => {
  if (!endDate) return null;
  const [y, m, d] = endDate.split(/[-T]/);
  const end = new Date(Number(y), Number(m) - 1, Number(d));
  if (Number.isNaN(end.getTime())) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)), 0);
};

/** 契約終了日までの残り日数ラベルを返す */
export const getRemainingDaysLabel = (endDate: string | null | undefined): string => {
  const days = getRemainingDays(endDate);
  if (days === null) return '残り--日';
  return `残り${days}日`;
};

/** 組織のプラン名を返す（未設定時は '-'） */
export const getPlanLabel = (organization: AdminApiOrganization): string =>
  organization.plan ?? '-';

/** 契約期間の残り割合を 0〜1 で返す（残り日数ベースで計算、最大365日） */
export const getProgressValue = (organization: AdminApiOrganization): number => {
  const remainingDays = getRemainingDays(organization.contract_end_date);
  if (remainingDays === null) return 0;

  // 最大365日を基準として計算（1年契約を想定）
  const maxDays = 365;
  return Math.min(Math.max(remainingDays / maxDays, 0), 1);
};

/** date input 用に日時文字列から日付部分のみ取り出す */
export const toDateInputValue = (value: string | null): string => {
  if (!value) return '';
  return value.split(' ')[0];
};
